// Lucide icon: bell (https://lucide.dev/icons/bell)
import { Bell } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconNotification = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Bell />
    </IconComponentStyled>
  )
}
